import React from 'react'
import ReactDOM from 'react-dom'
import './modal.css'
import { graphql } from 'react-apollo'
import { ME } from 'operations/User'
import moment from 'moment'

const modalRoot = document.getElementById('modal-root');

class Modal extends React.Component {

    constructor(props) {
        super(props)
        this.el = document.createElement('div')
        this.el.setAttribute('id', 'modal__wrapper')
        this.props.transparent && this.el.setAttribute('class', 'modal--transparent')
    }

    componentDidMount() {
        const { me } = this.props.data
        if (me) {
            const downShift = !me.isVerified || (!me.account.stripeCustomerId && me.account.trialEnd < moment())
            if (downShift) {
                this.el.setAttribute('class', 'modal--downShift')
            }
        }
        modalRoot.appendChild(this.el)
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el)
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        )
    }

}

export default graphql(ME)(Modal)


// WEBPACK FOOTER //
// ./src/components/Modal/index.js